module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inventory d-flex flex-column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flexGrow1 overflow-auto"
  }, [_c('tabs', {
    on: {
      "changed": _vm.tabChanged
    }
  }, [_c('tab', {
    attrs: {
      "name": "Products"
    }
  }, [_c('Products', {
    attrs: {
      "showInactiveProducts": _vm.initPayload.showInactiveProducts
    },
    on: {
      "showInactiveProducts": function($event) {
        return _vm.showInactiveProducts($event)
      }
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Services"
    }
  }, [_c('Extras', {
    attrs: {
      "showInactiveExtras": _vm.initPayload.showInactiveExtras
    },
    on: {
      "showInactiveExtras": function($event) {
        return _vm.showInactiveExtras($event)
      }
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Resources"
    }
  }, [_c('Resources', {
    attrs: {
      "showInactiveResources": _vm.initPayload.showInactiveResources
    },
    on: {
      "showInactiveResources": function($event) {
        return _vm.showInactiveResources($event)
      }
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Categories"
    }
  }, [_c('categories')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Transports"
    }
  }, [_c('transports')], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "navigator"
  }, [_c('h2', {
    staticClass: "mr-auto"
  }, [_vm._v("My Inventory")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-14961523", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14961523"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/Inventory.vue
// module id = 3000
// module chunks = 0